import type { RouteRecordRaw } from "vue-router";

const Layout = () => import("@/layout/index.vue");

const systemRoutes: RouteRecordRaw = {
  path: "/system",
  component: Layout,
  redirect: "/system/systemUser",
  name: "SystemManagement",
  meta: {
    title: "系统管理",
    icon: "system",
    permissionKey: "system",
  },
  children: [
    {
      path: "systemUser",
      name: "SystemUser",
      component: () => import("@/views/Workbench/system-user/user-list.vue"),
      meta: {
        title: "用户管理",
        icon: "homepage",
        permissionKey: "system:systemUser",
      },
    },
    {
      path: "userSchoolAuth",
      name: "SystemUserSchoolAuth",
      component: () =>
        import("@/views/Workbench/teacher-management/user-school-auth/index.vue"),
      meta: {
        title: "学校授权",
        hidden: true,
        icon: "homepage",
        permissionKey: "system:userSchoolAuth",
      },
    },
    {
      path: "userSchoolAuthAll",
      name: "SystemUserSchoolAuthAll",
      component: () =>
        import("@/views/Workbench/teacher-management/user-school-auth-all/index.vue"),
      meta: {
        title: "批量学校授权",
        hidden: true,
        icon: "homepage",
        permissionKey: "system:userSchoolAuthAll",
      },
    },
    {
      path: "salesList",
      name: "SalesList",
      component: () =>
        import("@/views/Workbench/system-user/sales-manager.vue"),
      meta: {
        title: "业务员管理",
        icon: "homepage",
        permissionKey: "system:salesList",
      },
    },
    {
      path: "setupFile",
      name: "SetupFile",
      component: () =>
        import("@/views/Workbench/system-upgrade/setup-file-list.vue"),
      meta: {
        title: "升级记录",
        icon: "homepage",
        permissionKey: "system:setupFile",
      },
    },
    {
      path: "setupFileEditor",
      name: "SetupFileEditor",
      component: () =>
        import("@/views/Workbench/system-upgrade/setup-file-editor.vue"),
      meta: {
        title: "升级编辑",
        hidden: true,
        icon: "homepage",
        permissionKey: "system:setupFileEditor",
      },
    },
    {
      path: "installFile",
      name: "InstallFile",
      component: () =>
        import("@/views/Workbench/system-upgrade/install-file-list.vue"),
      meta: {
        title: "安装文件",
        icon: "homepage",
        permissionKey: "system:softwareUpgrade",
      },
    },
    {
      path: "systemLog",
      name: "SystemLog",
      component: () => import("@/views/Workbench/system-log/index.vue"),
      meta: {
        title: "系统日志",
        icon: "homepage",
        permissionKey: "system:systemLog",
      },
    },
    {
      path: "contractTemplate",
      name: "SystemContractTemplate",
      component: () =>
        import("@/views/Workbench/school-management/contract-template-list/index.vue"),
      meta: {
        title: "合同模板",
        icon: "homepage",
        permissionKey: "system:contractTemplate",
      },
    },
    {
      path: "systemManage",
      name: "SystemManage",
      component: () => import("@/views/Workbench/system-manage/index.vue"),
      meta: {
        title: "系统管理",
        icon: "homepage",
        permissionKey: "system:systemManage",
      },
    },
    {
      path: "rolePermissionManager",
      name: "RolePermissionManager",
      component: () =>
        import("@/views/Workbench/system-user/role-permission-manager.vue"),
      meta: {
        title: "角色权限",
        icon: "homepage",
        permissionKey: "system:rolePermissionManager",
      },
    },
  ],
};

export default systemRoutes;
